<template>
  <div v-if="testimonials.length" class="residency__testimonials">
    <v-heading level="h3">Depoimentos sobre o curso</v-heading>
    <v-container>
      <div class="testimonials">
        <div class="testimonials__cards">
          <v-card v-for="(testimonial, tindex) in testimonials.slice(0, 3)" :key="tindex">
            <h4>{{testimonial.title}}</h4>
            <p>{{testimonial.testimonial}}.</p>
            <a href="/" @click.prevent="openOnIndex(tindex)">Continuar Lendo</a>
          </v-card>
        </div>
        <div class="testimonials__actions">
          <v-btn
            model="color-d"
            :outline="true"
            @click="openOnIndex(0)">
              Ver mais antigos
          </v-btn>
        </div>
      </div>
    </v-container>
    <v-lightbox @close="isLightboxVisible = false" :active="isLightboxVisible">
      <div class="testimonials-list">
        <div class="panel-top">
          <div>
            <v-heading class="control" level="h4">
              <img class="prev" src="@/assets/img/arrow.svg" @click="prev()">
              <span>Depoimentos sobre o curso</span>
              <img class="next" src="@/assets/img/arrow.svg" @click="next()">
            </v-heading>
            <p>{{testimonialIndex+1}} de {{testimonials.length}}</p>
          </div>
        </div>
        <div class="testimonial">
          <div class="block">
            <h3>{{testimonials[testimonialIndex].title}}</h3>
            <p class="words">{{testimonials[testimonialIndex].testimonial}}.</p>
          </div>
          <div class="block">
            <p class="date">{{testimonials[testimonialIndex].date}}</p>
            <p class="who">{{testimonials[testimonialIndex].name}}</p>
          </div>
        </div>
      </div>
    </v-lightbox>
  </div>
</template>

<script>
import Container from '@/components/layout/Container.vue';
import Heading from '@/components/uikit/text/Heading.vue';
import Card from '@/components/layout/Card.vue';
import Lightbox from '@/components/layout/Lightbox.vue';
import Btn from '@/components/uikit/Btn.vue';

export default {
  name: 'ResidencyTestimonials',
  props: {
    testimonials: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    'v-heading': Heading,
    'v-container': Container,
    'v-lightbox': Lightbox,
    'v-card': Card,
    'v-btn': Btn,
  },
  methods: {
    next() {
      return this.testimonialIndex < this.testimonials.length - 1 ? this.testimonialIndex++ : this.testimonials.length - 1;
    },
    prev() {
      return this.testimonialIndex > 0 ? this.testimonialIndex-- : 0;
    },
    openOnIndex(index) {
      this.isLightboxVisible = true;
      return this.testimonialIndex = index;
    },
  },
  data() {
    return {
      isLightboxVisible: false,
      testimonialIndex: 0,
    };
  },
  created() {
    window.addEventListener('keydown', (e) => {
      if (e.keyCode == 37) this.prev();
      if (e.keyCode == 39) this.next();
    });
  },
};
</script>

<style lang="scss">
$component: '.residency__testimonials';
#{$component} {
  padding: $section-gutter 0;
  background-color: $bg-gray;
  > h3.heading  {
    color: $color-d;
    text-align: center;
    padding-bottom: $gutter-xxl;
  }
  h4 {
    margin: 0;
    margin-bottom: 16px;
  }
  .testimonials {
    &__cards {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: $gutter-xxl;
      @media screen and(max-width: 640px){
        flex-flow: column;
      }
      .card {
        height: 290px;
        position: relative;
        width: 100%;
        margin: 8px;
        padding: 24px;
        padding-bottom: $gutter-xl;
        h4 {
          margin-bottom: $gutter-l;
        }
        p {
          word-break: break-all;
          height: calc(100% - 72px);
          color: $color-sys-e;
          position: relative;
          overflow: hidden;
          &:before {
            z-index: 1;
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 72px;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.0001) 3.94%, #FFFFFF 100%);
          }
        }
        a {
          z-index: 1;
          position: absolute;
          bottom: 0;
          padding: $gutter-xl 0;
          left: 0;
          width: 100%;
          display: block;
          text-align: center;
          font-size: $font-size;
          font-weight: 600;
          text-align: center;
          text-decoration: none;
          color: $color-a;
          transition: 200ms ease-in-out;
          &:hover {
            color: lighten($color-a, 12%);
          }
        }
      }
    }
    &__actions {
      text-align: center;
    }
  }
  .lightbox {
    grid-template-columns: 1fr minmax(280px, 560px) 1fr;
    .lightbox__panel {
      padding: 0 !important;
    };
    .testimonials-list {
      .panel-top {
        position: relative;
        height: 128px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        border-bottom: solid 1px #E5E7EB;
        > div {
          text-align: center;
          h4{
            display: block;
            color: $color-d;
            margin-bottom: 8px;
          }
          p {
            color: #768091;
            width: 100%;
            margin: 0;
          }
          .control {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: $font-size-xl;
            span{
              padding: 0 80px;
            }
            @media screen and(max-width: 768px) {
              font-size: $font-size-l;
            }
            @media screen and(max-width: 500px) {
              span {
                padding: 0 10px;
              }
            }
            img {
              transition: 200ms ease-in-out;
              cursor: pointer;
              opacity: .6;
            }
            .prev {
              transform: rotate(180deg);
              &:hover {
                transform: translateX(-3px) rotate(180deg);
              }
            }
            .next {
              &:hover{
                transform: translateX(3px);
              }
            }
          }
        }
      }
      .testimonial {
        padding: 48px;
        padding-top: $gutter-xxl;
        @media screen and(max-width: 425px) {
          padding: $gutter-xxl $gutter-l;
        }
        h3 {
          margin-top: 0;
        }
        p {
          color: $color-sys-e;
          &.words {
            padding-bottom: $gutter-xl;
            margin-bottom: 0;
            overflow: hidden;
          }
          &.date {
            margin: 0;
            margin-bottom: 8px;
          }
          &.who {
            margin: 0;
            font-weight: 700;
          }
        }
      }
    }
  }
}
</style>
